import type {Appraisal} from '~/types/domain/Appraisals';

export type AppraisalItem = {
    id: string;
    date: Date;
    authorImgUrl: string;
    authorName: string;
    authorCompanyName: string;
    authorJobTitle: string | undefined;
    comment: string;
};

export enum AppraisalItemSize {
    SMALL = 'small',
    LARGE = 'large',
}

export function toAppraisalItem(appraisal: Appraisal): AppraisalItem {
    return {
        id: appraisal.id,
        date: new Date(appraisal.creationDate),
        authorImgUrl: appraisal.clientImageUrl,
        authorName: appraisal.clientName,
        authorCompanyName: appraisal.clientCompanyName,
        authorJobTitle: appraisal.clientJobTitle,
        comment: appraisal.comment,
    };
}

export function toAppraisalItems(appraisals: Appraisal[]): AppraisalItem[] {
    return appraisals.map((appraisal) => toAppraisalItem(appraisal));
}
